module.exports = __webpack_public_path__ + "../resources/images/promos-21deba3a0acade4f0806e5cd11bff32b.svg";